import { ChatService } from "./../../chat.service";
import { Firestore, collection, addDoc } from "@angular/fire/firestore";
import { HotToastService } from "@ngneat/hot-toast";
import {
  Component,
  OnInit,
  ViewChild,
  inject,
  ChangeDetectorRef,
  ElementRef,
} from "@angular/core";

import { LocalStorageService } from "src/app/utils/localstorage.service";
import { DashboardService } from "../../dashboard.service";
import { TrackedItemsDashboardService } from "./tracked-items-dashboard.service";
import { BsModalRef } from "ngx-bootstrap/modal";
import { ConversationsService } from "../../conversations/conversations.service";
import * as _ from "underscore";
import { Conversation } from "../../conversations/panels/conversation.model";
import { DashboardStore } from "../../dashboard.store";
import { LazyLoadEvent, SharedModule } from "primeng/api";
import { ActiveClientsOnlyPipe } from "../common/active-clients-only.pipe";
import { MomentModule } from "ngx-moment";
import { TrackedItemBubbleComponent } from "../../conversations/tracked-item-bubble/tracked-item-bubble.component";
import { TableModule } from "primeng/table";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";

import { NgIf } from "@angular/common";
import { TagAddComponent } from "../common/tags/tag-add/tag-add.component";
import { TagComponent } from "../common/tags/tag.component";
import { SharedDataService } from "../../shared-data.service";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { FormsModule } from "@angular/forms";

import * as FileSaver from "file-saver";
import autoTable from "jspdf-autotable";
import { WorkSheet } from "xlsx";
import { EmptyStateComponent } from "src/app/design-system/components/empty-state/empty-state.component";

@Component({
  selector: "tracked-items-dashboard",
  templateUrl: "./tracked-items-dashboard.component.html",
  styleUrls: [
    "./tracked-items-dashboard.component.css",
    "../../main/accountant/jobs-and-tasks/time-tracking/time-tracking-dashboard/time-tracking-dashboard.component.scss",
  ],
  imports: [
    NgIf,
    BsDropdownModule,
    TableModule,
    SharedModule,
    TooltipModule,
    TrackedItemBubbleComponent,
    MomentModule,
    ActiveClientsOnlyPipe,
    TagAddComponent,
    TagComponent,
    FormsModule, // Add this
    EmptyStateComponent
],
})
export class TrackedItemsDashboardComponent implements OnInit {
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  user: any;
  data: any;
  company: any;
  tracked_items = [];
  active_template = {};
  show_templates = false;
  templates = [];
  dashboardName = "clientTasksDashboard";

  initialFilters = {
    [this.dashboardName]: {
      clientFilter: { label: "All clients", value: "all" },
      timeFrameFilter: { label: "Over 7 Days", value: "over" },
      statusFilter: { label: "Open", value: "open" },
      rows: 25,
    },
  };

  totalRecords: number = 0;
  loading: boolean = false;
  lastLazyEvent: LazyLoadEvent;

  current_conversation: Conversation;
  clients = [];
  firestore: Firestore = inject(Firestore);

  workspace_tags_filter: any = [];
  @ViewChild("workspaceFilterTagList") workspaceFilterTagList: TagAddComponent;
  @ViewChild("searchInput") searchInput: ElementRef;
  andOrWorkspaces: string = "or";

  cols = [
    { field: "client", header: "Client" },
    { field: "description", header: "Description" },
    { field: "created_by", header: "Created By" },
    { field: "status", header: "Status" },
  ];
  exportColumns: any[];

  filterText: string = "";
  filteredClients: any[] = [];

  constructor(
    private localStorage: LocalStorageService,
    private conversationsService: ConversationsService,
    public toastr: HotToastService,
    public dashboardService: DashboardService,
    private trackedItemsDashboardService: TrackedItemsDashboardService,
    private chatService: ChatService,
    public dashboardStore: DashboardStore,
    public sharedDataService: SharedDataService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    if (!this.dashboardService.filters()[this.dashboardName]) {
      this.dashboardService.filters.update((prevState = {}) => ({
        ...prevState,
        ...this.initialFilters,
      }));
    }
    this.workspace_tags_filter =
      this.localStorage.get("workspace_tags_filter") || [];

    this.andOrWorkspaces = this.localStorage.get("and_or_workspaces") || "or";

    // Watch for changes in all_clients
    this.dashboardStore.all_clients$.subscribe((clients) => {
      if (clients?.length) {
        this.filteredClients = [...clients];
        this.cdr.detectChanges();
      }
    });
  }

  filterClients() {
    if (!this.filterText?.trim()) {
      this.filteredClients = [...this.dashboardStore.all_clients];
    } else {
      const searchText = this.filterText.toLowerCase().trim();
      this.filteredClients = this.dashboardStore.all_clients.filter((client) =>
        client.name?.toLowerCase().includes(searchText),
      );
    }
    this.cdr.detectChanges(); // Add this to ensure view updates
  }

  clearSearch() {
    this.filterText = "";
    this.filterClients();
  }

  handleReminderSuccess(res: any) {
    this.toastr.success("Reminder sent successfully!");
  }

  handleError(err: any, message?: string) {
    let displayableMessage = err.message ? err.message : message;
    this.toastr.error(displayableMessage);
  }

  sendReminder(conversationUuid: string) {
    this.conversationsService.sendReminder(conversationUuid).then(
      (res) => this.handleReminderSuccess(res),
      (err) => this.handleError(err),
    );
  }

  send_reminder(conversation): void {
    var publishConfig = {
      channel: `conversation-${conversation.uuid}`,
      message: {
        message: "",
        tracked_item: null,
        system_message: true,
        file: null,
        date: this.chatService.getFirestoreServerDate(),
        reminder_creator: {
          full_name: this.localStorage.get("user")["full_name"],
          id: this.localStorage.get("user")["id"],
          email: this.localStorage.get("user")["email"],
        },
        sent_by: {
          full_name: this.localStorage.get("user")["full_name"],
          id: this.localStorage.get("user")["id"],
          email: this.localStorage.get("user")["email"],
        },
        reminder: true,
      },
    };

    this.dashboardService.show_loading.next(true);
    this.dashboardService.show_loading.next(true);

    addDoc(
      collection(this.firestore, `chats/${conversation.uuid}/messages`),
      publishConfig.message,
    )
      .then((res: any) => {
        this.dashboardService.show_loading.next(false);
        this.toastr.success("Reminder sent successfully!");
      })
      .catch((err) => {
        this.toastr.error("Error sending reminder");
      });
  }

  updateTrackedItemsTemplate() {
    this.dashboardService.show_loading.next(true);
    this.conversationsService
      .update_tracked_items_template(
        this.active_template["uuid"],
        this.active_template,
      )
      .subscribe(
        (res: any) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.success(res.message);
        },
        (err) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
        },
      );
  }

  deleteTrackedItemsTemplate() {
    this.dashboardService.show_loading.next(true);
    this.conversationsService
      .delete_tracked_items_template(this.active_template["uuid"])
      .subscribe(
        (res: any) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.success(res.message);

          this.templates = this.templates.filter((t) => {
            return t.id != this.active_template["id"];
          });

          this.active_template = {};

          if (this.templates.length > 0) {
            this.active_template = this.templates[0];
          }
        },
        (err) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
        },
      );
  }

  retrieveTrackedItems(event = null) {
    const {
      [this.dashboardName]: {
        clientFilter: { value: clientFilter },
        timeFrameFilter: { value: timeFrameFilter },
        statusFilter: { value: statusFilter },
      },
    } = this.dashboardService.filters();
    this.loading = true;
    if (event) this.lastLazyEvent = event;
    this.trackedItemsDashboardService
      .get_tracked_items(
        timeFrameFilter,
        statusFilter,
        clientFilter,
        this.workspace_tags_filter,
        this.andOrWorkspaces,
        this.lastLazyEvent.first,
        this.lastLazyEvent.rows,
      )
      .then((res: any) => {
        const response = res;
        this.tracked_items = response.tracked_items;
        this.totalRecords = response.total_count;
        this.loading = false;
      });
  }

  changeStatusFilter(status: string) {
    let label = status.charAt(0).toUpperCase() + status.slice(1);
    let value = status;
    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        statusFilter: { label, value },
      },
    }));
    this.retrieveTrackedItems();
  }

  changeTimeframeFilter(timeframe: string) {
    let label;
    switch (timeframe) {
      case "over":
        label = "Over 7 Days";
        break;
      case "between":
        label = "2 to 7 Days";
        break;
      case "close":
        label = "LESS than 2 Days";
        break;
      case "all":
        label = "All";
        break;
    }
    let value = timeframe;
    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        timeFrameFilter: { label, value },
      },
    }));
    this.retrieveTrackedItems();
  }

  changeClientFilter(client: string, clientName: string = "") {
    let value = client;
    let label = clientName ? clientName : "All clients";
    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        clientFilter: { label, value },
      },
    }));
    this.retrieveTrackedItems();
  }

  getClientCompanyName(clientId: number): any {
    const client = this.dashboardStore.all_clients.find(
      (client) => client.id === clientId
    );
    return { name: client?.name || 'Unknown Company' };
  }

  addTagToFilter(tag) {
    this.workspace_tags_filter = [...this.workspace_tags_filter, tag];
    this.workspaceFilterTagList.addedTags = this.workspace_tags_filter;

    this.localStorage.set("workspace_tags_filter", this.workspace_tags_filter);
    this.retrieveTrackedItems();
  }

  removeTagFromFilter(tag) {
    this.workspaceFilterTagList.tags.push(tag);
    this.workspace_tags_filter = this.workspace_tags_filter.filter((t) => {
      return t.uuid !== tag.uuid;
    });
    this.workspaceFilterTagList.addedTags = this.workspace_tags_filter;

    this.localStorage.set("workspace_tags_filter", this.workspace_tags_filter);

    this.localStorage.set("and_or_workspaces", this.andOrWorkspaces);
    this.retrieveTrackedItems();
  }

  clearFilter() {
    this.workspace_tags_filter = [];
    this.workspaceFilterTagList.tags = this.workspaceFilterTagList.all_tags;
    this.workspaceFilterTagList.addedTags = this.workspace_tags_filter;

    this.localStorage.set("workspace_tags_filter", this.workspace_tags_filter);
    this.retrieveTrackedItems();
  }

  onPageChange(event) {
    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        rows: event.rows,
      },
    }));
  }

  exportPdf() {
    const {
      [this.dashboardName]: {
        clientFilter: { value: clientFilter },
        timeFrameFilter: { value: timeFrameFilter },
        statusFilter: { value: statusFilter },
      },
    } = this.dashboardService.filters();
    this.loading = true;
    this.trackedItemsDashboardService
      .get_tracked_items(
        timeFrameFilter,
        statusFilter,
        clientFilter,
        this.workspace_tags_filter,
        this.andOrWorkspaces,
      )
      .then((res) => {
        let trackedItems = res.tracked_items;

        import("jspdf").then((jsPDF) => {
          import("jspdf-autotable").then((x) => {
            const doc = new jsPDF.default("l", "pt");
            autoTable(doc, {
              head: [this.cols.map((col) => col.header)],
              body: trackedItems.map((trackedItem: any) => {
                let clientName = "";

                this.dashboardStore.all_clients.forEach((client) => {
                  if (client.id === trackedItem.company) {
                    clientName = client.name;
                  }
                });

                let div = document.createElement("div");
                div.innerHTML = trackedItem.message;

                return [
                  clientName, // client
                  div.innerText, // description
                  trackedItem.created_by.full_name, // created_by
                  trackedItem.answer_status, // status
                ];
              }),
            });
            doc.save(
              `client_tasks_dashboard_${new Date()
                .toDateString()
                .replace(" ", "_")}.pdf`,
            );
          });
        });

        this.loading = false;
      });
  }

  exportExcel() {
    const {
      [this.dashboardName]: {
        clientFilter: { value: clientFilter },
        timeFrameFilter: { value: timeFrameFilter },
        statusFilter: { value: statusFilter },
      },
    } = this.dashboardService.filters();
    this.loading = true;
    this.trackedItemsDashboardService
      .get_tracked_items(
        timeFrameFilter,
        statusFilter,
        clientFilter,
        this.workspace_tags_filter,
        this.andOrWorkspaces,
      )
      .then((res) => {
        let trackedItems = res.tracked_items;

        import("xlsx").then((xlsx) => {
          let formattedTrackedItems = trackedItems.map((trackedItem: any) => {
            let clientName = "";

            this.dashboardStore.all_clients.forEach((client) => {
              if (client.id === trackedItem.company) {
                clientName = client.name;
              }
            });

            let div = document.createElement("div");
            div.innerHTML = trackedItem.message;

            return {
              client_name: clientName, // client
              description: div.innerText, // description
              created_by: trackedItem.created_by.full_name, // created_by
              status: trackedItem.answer_status, // status
            };
          });

          const wb = xlsx.utils.book_new();
          const ws: WorkSheet = xlsx.utils.json_to_sheet([]);
          xlsx.utils.sheet_add_aoa(ws, [this.cols.map((col) => col.header)]);

          xlsx.utils.sheet_add_json(ws, formattedTrackedItems, {
            origin: "A2",
            skipHeader: true,
          });

          xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
          xlsx.writeFile(
            wb,
            `client_tasks_dashboard_${new Date().toDateString()}.xlsx`,
          );

          this.loading = false;

          // this.saveAsExcelFile(file, "jobs");
        });
      });
  }

  async exportCsv(): Promise<void> {
    const {
      [this.dashboardName]: {
        clientFilter: { value: clientFilter },
        timeFrameFilter: { value: timeFrameFilter },
        statusFilter: { value: statusFilter },
      },
    } = this.dashboardService.filters();
    this.loading = true;
    this.trackedItemsDashboardService
      .get_tracked_items(
        timeFrameFilter,
        statusFilter,
        clientFilter,
        this.workspace_tags_filter,
        this.andOrWorkspaces,
      )
      .then((res) => {
        let csvContent = "data:text/csv;charset=utf-8,";
        const exportCols = this.cols.map((col) => col.header);
        csvContent += exportCols.join(",") + "\n";

        let trackedItems = res.tracked_items;

        trackedItems.forEach((trackedItem: any) => {
          let clientName = "";

          this.dashboardStore.all_clients.forEach((client) => {
            if (client.id === trackedItem.company) {
              clientName = client.name;
            }
          });

          let div = document.createElement("div");
          div.innerHTML = trackedItem.message;

          const rowData = [
            clientName, // client
            `"${div.innerText}"`, // description
            trackedItem.created_by.full_name, // created_by
            trackedItem.answer_status, // status
          ];
          csvContent += rowData.join(",") + "\n";
        });

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute(
          "download",
          `client_tasks_dashboard_data_dashboard_${new Date()
            .toDateString()
            .replace(" ", "_")}.csv`,
        );
        document.body.appendChild(link);
        link.click();
        this.loading = false;
      });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      `client_tasks_dashboard_${new Date()
        .toDateString()
        .replace(" ", "_")}${EXCEL_EXTENSION}`,
    );
  }

  onDropdownShown(): void {
    setTimeout(() => {
      this.searchInput?.nativeElement?.focus();
    });
  }
}
